import { keywordSearchSlice } from './keywordSearch.slice';

export const KEYWORD_SEARCH_REDUCER_KEY = keywordSearchSlice.name;
export const keywordSearchReducer = keywordSearchSlice.reducer;
